/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Vlaidslav Oshkanov
 * @author Yakov Gushchin
 * @version 1.0.0
 * @since 1.0.0
 */
import styled from 'styled-components';

import { colors } from '../../../../../theme';

const DragItemContainerStyled = styled.div`
    display: flex;
`;

const ItemBodyStyled = styled.div.attrs(() => ({
    className: 'table-setting-wrapper__setting-body-row',
}))`
    width: 100%;
    display: flex;
    justify-content: space-between;
    background-color: ${colors.dragAndDropItemBgColor};
    border-bottom: 1px solid ${colors.dragAndDropItemBorderColor};
`;

const HandleContainerStyled = styled.div`
    display: flex;
    align-self: center;
`;

const IconStyled = styled.img.attrs(() => ({
    'data-drag-and-drop-item-img': 'dragAndDropItemImg',
}))`
    width: 32px;
`;

export {
    DragItemContainerStyled,
    HandleContainerStyled,
    IconStyled,
    ItemBodyStyled,
};
